module.exports = __webpack_public_path__ + "static/media/elixir-safety.82c3685f.pdf";